import { Component, OnInit } from '@angular/core';

@Component({
    template: `<ngx-loading [show]="true" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>`
})
export class LogoffComponent  {
    constructor() {
    }
}
